<template>
  <div class="comment-list-item">
    <div class="comment-list-item-avatar">
      <img :src="avatar(comment)"
           class="avatar">
    </div>

    <div class="comment-list-item-body">
      <div class="comment-list-item-body-header">
        <h4 class="comment-list-item-body-header-name">{{comment.clienteNome ? comment.clienteNome : $t('message.generics.message.notInformed')}}</h4>
        <span v-if="comment.clienteEmail" class="comment-list-item-body-header-email">({{ comment.clienteEmail }})</span>
        <!-- <div class="comment-list-item-body-header-date">{{$date.format(new Date(comment.data))}}</div> -->
      </div>

      <div class="comment-list-item-body-msg">
        {{comment.observacao}}
      </div>

      <div class="comment-list-item-body-badges">
        <Badge :text="comment.data"
               icon="calendar" />
        <Badge :text="comment.localNome"
               icon="map-marker-outline" />
        <Badge :text="comment.campanhaNome"
               icon="bullhorn-outline" />
      </div>
    </div>

    <div v-if="comment.clienteEmail" class="comment-list-item-action">
      <a :href="mailto">
        <i class="mdi mdi-email-outline"></i>
      </a>
    </div>

  </div>
</template>

<script>
  import Badge from '@components/Badge'

    export default {
      components: {
        Badge
      },
        props: {
          comment: {
            type: Object,
            required: true
          }
        },

        data() {
            return {

            }
        },

        methods: {
          avatar(comment) {
            if(comment.urlAvatar){
              let http = new XMLHttpRequest();
  
              http.open('HEAD', comment.urlAvatar, false);
              http.send();
  
              if(http.status === 200) {
                return comment.urlAvatar;
              }
            }

            return '/images/user-avatar-placeholder.png';
          } 
        },

        computed: {
          mailto() {
            return `mailto:${this.comment.clienteEmail}`
          }
        }

    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.comment-list-item {
  display: flex;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #c2c2c2;
  align-items: center;
  padding-right: 50px;

  .comment-list-item-avatar {
    margin-right: 15px;
  }

  .comment-list-item-body {
    flex: 1;

    .comment-list-item-body-header {
      display: flex;
      align-items: center;
      width: 100%;
      margin-bottom: 5px;

      .comment-list-item-body-header-name {
        margin: 0 5px 0 0;
      }

      .comment-list-item-body-header-email {
        font-size: 12px;
      }

      .comment-list-item-body-header-date {
        margin-left: auto;
      }
    }

    .comment-list-item-body-msg {
      margin-bottom: 10px;
    }

    .comment-list-item-body-badges {
      display: flex;

      .badge {
        margin-right: 10px;
      }
    }
  }

  .comment-list-item-action {
    margin-left: auto;

    i {
      color: $blue-primary;
      font-size: 24px;
    }
  }
}
</style>
